// src/modules/app-views/serviceOrders/pages/Document/decorators/request.js
// *******************************************************************************
// REQUEST DECORATOR
// Transforms data before sending to the server
// *******************************************************************************

/**
 * Transforms form data before sending to the server
 *
 * @param {Object} ctx - Context object
 * @param {Object} ctx.data - Form data to be sent (changed fields only)
 * @param {Object} ctx.allValues - Complete form data with original values
 * @param {String} ctx.url - Request URL
 * @param {String} ctx.method - HTTP method
 * @returns {Object} Transformed data ready for backend
 */
const decorateRequest = ctx => {
  const { data, allValues } = ctx;

  if (!data) return data;

  // Clone data to avoid mutations
  const transformed = { ...data };

  // ───────────────────────────────────────────────────────────────────────────
  // ITEMS RE-INDEXING
  // Ensure items have correct sortOrder
  // ───────────────────────────────────────────────────────────────────────────
  if (transformed.items && Array.isArray(transformed.items)) {
    transformed.items = transformed.items.map((item, index) => ({
      ...item,
      sortOrder: index + 1,
    }));
  }

  // ───────────────────────────────────────────────────────────────────────────
  // TOTALS - Ensure numeric values
  // ───────────────────────────────────────────────────────────────────────────
  if (transformed.grandTotal !== undefined) {
    transformed.grandTotal = Number(transformed.grandTotal) || 0;
  }
  if (transformed.servicesTotal !== undefined) {
    transformed.servicesTotal = Number(transformed.servicesTotal) || 0;
  }
  if (transformed.productsTotal !== undefined) {
    transformed.productsTotal = Number(transformed.productsTotal) || 0;
  }
  if (transformed.discountTotal !== undefined) {
    transformed.discountTotal = Number(transformed.discountTotal) || 0;
  }

  // ───────────────────────────────────────────────────────────────────────────
  // ATTACHMENTS TRANSFORMATION
  // ───────────────────────────────────────────────────────────────────────────
  const attachmentTypes = [
    'avatar',
    'logo',
    'cover',
    'gallery',
    'document',
    'contract',
    'qrcode',
    'signature',
    'other',
  ];

  attachmentTypes.forEach(attachType => {
    if (data[attachType] && typeof data[attachType] === 'object') {
      const originalAttachment = allValues?.attachments?.find(
        a => a.attachmentType === attachType
      );

      const attachObj = { ...data[attachType] };
      if (attachObj.id && !attachObj.attachmentId) {
        attachObj.attachmentId = attachObj.id;
        delete attachObj.id;
      }

      transformed[attachType] = {
        ...attachObj,
        _id: originalAttachment?._id,
      };
    }
  });

  return transformed;
};

export default decorateRequest;
